import http from "@/settings/apiSettings"

class CrmTargetDataService{
  save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_Target", data);
      }
  
}
export default new CrmTargetDataService();